/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalRegulationObligationRuleControlsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.IInternalRegulationObligationRuleControlsInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IInternalRegulationObligationRuleControlsQuery = {
  __typename?: 'Query';
  internalRegulationObligationRuleControls: {
    __typename: 'InternalRegulationObligationRuleControlConnection';
    edges: Array<{
      __typename: 'InternalRegulationObligationRuleControlEdge';
      cursor: string;
      node: {
        __typename: 'InternalRegulationObligationRuleControl';
        id: string;
        regulationObligationRuleId: string;
        controlId: string;
        isFromModel: boolean;
        control?: {
          __typename: 'InternalControl';
          id: string;
          code: string;
          latestName?: string | null;
          latestInstance?: {
            __typename: 'InternalControlInstance';
            id: string;
            controlId: string;
            name: string;
            descriptionReview?: string | null;
            descriptionIdentify?: string | null;
            descriptionAction?: string | null;
            objective?: string | null;
            type?: string | null;
            automation?: string | null;
          } | null;
        } | null;
      };
    }>;
    pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export const InternalRegulationObligationRuleControlsDocument = gql`
  query InternalRegulationObligationRuleControls(
    $input: InternalRegulationObligationRuleControlsInput
    $first: Int
    $after: String
  ) {
    internalRegulationObligationRuleControls(input: $input, first: $first, after: $after) {
      __typename
      edges {
        __typename
        node {
          __typename
          id
          regulationObligationRuleId
          controlId
          isFromModel
          control {
            __typename
            id
            code
            latestName
            latestInstance {
              __typename
              id
              controlId
              name
              descriptionReview
              descriptionIdentify
              descriptionAction
              objective
              type
              automation
            }
          }
        }
        cursor
      }
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useInternalRegulationObligationRuleControlsQuery__
 *
 * To run a query within a React component, call `useInternalRegulationObligationRuleControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalRegulationObligationRuleControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalRegulationObligationRuleControlsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInternalRegulationObligationRuleControlsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IInternalRegulationObligationRuleControlsQuery,
    IInternalRegulationObligationRuleControlsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IInternalRegulationObligationRuleControlsQuery,
    IInternalRegulationObligationRuleControlsQueryVariables
  >(InternalRegulationObligationRuleControlsDocument, options);
}
export function useInternalRegulationObligationRuleControlsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IInternalRegulationObligationRuleControlsQuery,
    IInternalRegulationObligationRuleControlsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IInternalRegulationObligationRuleControlsQuery,
    IInternalRegulationObligationRuleControlsQueryVariables
  >(InternalRegulationObligationRuleControlsDocument, options);
}
// @ts-ignore
export function useInternalRegulationObligationRuleControlsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IInternalRegulationObligationRuleControlsQuery,
    IInternalRegulationObligationRuleControlsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IInternalRegulationObligationRuleControlsQuery,
  IInternalRegulationObligationRuleControlsQueryVariables
>;
export function useInternalRegulationObligationRuleControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalRegulationObligationRuleControlsQuery,
        IInternalRegulationObligationRuleControlsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IInternalRegulationObligationRuleControlsQuery | undefined,
  IInternalRegulationObligationRuleControlsQueryVariables
>;
export function useInternalRegulationObligationRuleControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalRegulationObligationRuleControlsQuery,
        IInternalRegulationObligationRuleControlsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IInternalRegulationObligationRuleControlsQuery,
    IInternalRegulationObligationRuleControlsQueryVariables
  >(InternalRegulationObligationRuleControlsDocument, options);
}
export type InternalRegulationObligationRuleControlsQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationRuleControlsQuery
>;
export type InternalRegulationObligationRuleControlsLazyQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationRuleControlsLazyQuery
>;
export type InternalRegulationObligationRuleControlsSuspenseQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationRuleControlsSuspenseQuery
>;
export type InternalRegulationObligationRuleControlsQueryResult = Apollo.QueryResult<
  IInternalRegulationObligationRuleControlsQuery,
  IInternalRegulationObligationRuleControlsQueryVariables
>;
